import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getTranslations = createAsyncThunk("translation/getTranslations", async () => {
  try {
    const response = await axios.get(`/GetUserTranslations`);
    return response.data;
  } catch (error) {
    return error;
  }
});